<template>
    <div class="woocommerce-variation--detail u-border-black-50--1 p-1 p-lg-2 mb-2" :class="{'d-none': id === false}" v-if="hasSku">
        <div
            v-if="hasSku || hasMoldNumber"
            class="u-text-upper u-font-600 mb-1 d-flex justify-content-between justify-content-md-start"
        >
            <div v-if="hasSku" class="mr-2">
                <span class="u-font-400">{{ itemCode }}:</span> {{sku}}
            </div>
            <div v-if="hasMoldNumber">
                <span class="u-font-400">{{labels.moldNumber}}:</span> {{moldNumber}}
            </div>            
        </div>        
        <table class="table--product-variation mb-2">
            <thead>
                <tr>
                    <th v-if="size">{{labels.size}}</th>
                    <th v-if="overflow">{{labels.overflow}}</th>
                    <th v-if="neckFinish">{{labels.neckFinish}}</th>
                    <th v-if="casePack">{{labels.casePack}}</th>
                    <th v-if="weight">{{labels.weight}}</th>
                    <th v-if="dimensions">{{labels.dimensions}}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td v-if="size">{{size}}</td>
                    <td v-if="overflow">{{overflow}}</td>
                    <td v-if="neckFinish">{{neckFinish}}</td>
                    <td v-if="casePack">{{casePack}}</td>
                    <td v-if="weight">{{weight}}</td>
                    <td v-if="dimensions">{{dimensions}}</td>
                </tr>
            </tbody>
        </table>
        <slot v-if="isInStock"></slot>
        <input type="hidden" name="variation_id" class="variation_id" v-model.number="variation_id">
    </div>    
</template>
<script>
export default {
    data() {
        return {
            id: null,
            size: null,
            sku: false,
            overflow: '',
            neckFinish: '',
            casePack: '',
            moldNumber: '',
            round: 'no',
            weight: 0,
            width: 0,
            height: 0,
            depth: 0,
            variation_id: 0,
            isInStock: false,
            // labels: {
            //         size : "Size",
            //         overflow : "Overflow",
            //         neckFinish : "Neck Finish",
            //         casePack : "Case Pack",
            //         weight : "Weight",
            //         dimensions : "Dimensions"
            //     }
        }
    },
    computed : {
        isRound : function() {
            switch (this.round) {
                case true:
                case "yes":
                    return true;
                    break;
            
                default:
                    return false;
                    break;
            }
        },
        itemCode() {
          return TG.vue.labels.misc.item_code || "Item Code"
        },
        labels() {
          return TG.vue.labels.product_attributes
        },
        dimensions : function() {
            if (this.width && this['length'] && this.height) {
                return false;
            }
            var dims = "";

            if (this.height) {
                dims += `${this.height}`;
            }

            if (this.isRound) {
                dims += ` x ${this.width}`;
            } else {
                if (this.width) {
                    dims += ` x ${this.width}`;
                }
                if (Number(this.depth) > 0) {
                    dims += ` x ${this.depth}`;
                }
            }

            return dims;
        },
        hasSku() {
            return this.sku.length > 0
        },
        hasMoldNumber() {
            return this.moldNumber.length > 0
        }
    },
    methods: {
        updateData(event, variation) {
            this.variation_id = variation.variation_id
            this.isInStock = variation.is_in_stock
            const customKeys = ['casePack', 'neckFinish', 'overflow', 'labels', 'moldNumber']
            const {sku, round, weight} = variation
            const {height, width, length} = variation.dimensions
            const tableData = {
                sku,
                round,
                weight,
                height,
                width,
                depth: length,
                id: variation.variation_id,
                size: variation.attributes.attribute_size
            }

            customKeys.forEach((key) => {
                if (variation.hasOwnProperty(key)) {
                    tableData[key] = variation[key];
                }
            })

            Object.assign(this, tableData)
            
        },
        resetData(event) {
            const tableData = {
                sku: false,
                round: 'no',
                weight: 0,
                height: 0,
                width: 0,
                depth: 0,
                id: null,
                size: null,
            }

            Object.assign(this, tableData)
        }
    },
    beforeMount() {
        jQuery(document.body).on('found_variation', 'form.cart', this.updateData);
        jQuery(document.body).on('reset_data', 'form.cart', this.resetData); 
    }
}
</script>